import React from 'react';
import { Address, Checkboxes, EmailAddressValidator, PhoneNumberValidator, Radio, RequiredValidator, Switch, TextArea, TextField, useFormContext } from '../../../Components/Form';
import Accordion, {Panel} from '../../../Components/Containers/Accordion';


const TermsOfService = ({templateOptions}) => {
    const {isValidating} = useFormContext();

    return <Accordion showErrorBadges={isValidating}>
        <Panel title="Data Controller Details">

            <TextField name="businessLegalName"
                label="Business Legal Name"
                validators={[RequiredValidator]}
            />

            <Address name="contactAddress"
                label="Business Address"
                validators={[RequiredValidator]}
            />

            <TextField name="contactEmail"
                label="Contact Email"
                type="email"
                validators={[RequiredValidator, EmailAddressValidator]}
            />

            <TextField name="contactPhone"
                label="Contact phone number"
                type="tel"
                validators={[RequiredValidator, PhoneNumberValidator]}
            />

            <TextField name="icoRegistration"
                label="ICO Registration reference"
                help="Are you registered with the ICO? If so, please provide your registration reference."
            />
        </Panel>

        <Panel title="Legal and Compliance">
            <Switch name="legalCompliance"
                label="Obligations"
                innerLabel="Are you aware of your obligations under UK GDPR and Data Protection Act 2018?"
            />
            <Radio name="dataRequest"
                label="Data subject access requests"
                help="Do you have a process for responding to data subjects' rights requests?"
                options={[
                    'No process in place',
                    'Contact us via the Customer Portal',
                    'Contact us via email',
                    'Contact us via phone',
                    'Contact us via post',
                ]}
            />
            <Radio name="dataBreach"
                label="Data breach notification"
                help="Do you have a plan in place for notifying the ICO and affected data subjects in the event of a data breach?"
                options={[
                    'No plan in place',
                    'We will notify the ICO and affected data subjects within 72 hours',
                ]}
            />
            <TextArea name="legalComplianceOther"
                label="Any additional information on legal compliance"
            />
        </Panel>


        <Panel title="Data use">
            <Checkboxes name="dataUses"
                label="Data uses"
                options={[
                    'Analytics',
                    'Customer support',
                    'Legal Compliance',
                    'Loyalty Programs',
                    'Marketing',
                    'Scheduling and Managing Appointments',
                ]}
                help="Select all the ways you use customer data"
            />
            <TextArea name="dataUsesOther"
                label="Additional data uses"
            />
        </Panel>


        <Panel title="Data transfer">
            <Radio name="dataTransfer"
                label="Data transfer"
                options={[
                    'Within the UK',
                    'Within the EEA',
                    'Outside the EEA',
                ]}
                help="Do you transfer data outside of the UK or EEA?"
            />
            <Radio name="dataOwnership"
                label="Data ownership"
                options={[
                    'We share data with third parties',
                    'We sell data to third parties',
                    'We do not share or sell data',
                ]}
            />
            <TextArea name="dataTransferOther"
                label="Additional data transfer information"
            />
        </Panel>


        <Panel title="Data processing">

            <Checkboxes name="dataStorage"
                label="Data storage"
                options={[
                    'In a secure data center',
                    'Encrypted at rest',
                    'Encrypted in transit',
                ]}
                help="Data stored within getSoapy is encrypted at rest and in transit. If you store data elsewhere and it is not encrypted you shouldn't select these options."
            />

            <TextArea name="subProcessors"
                label="Sub processors"
                validators={[]}
                help="List all the services you use which will handle customer data, i.e. your sub processors"
            />
        </Panel>

        {/* More */}

        <Panel title="Additional details">

            <TextArea name="additionalInformation" label="Additional details" />

        </Panel>
    </Accordion>;
}

export default TermsOfService;
